import { render, staticRenderFns } from "./tradelist.vue?vue&type=template&id=5b6f2252&scoped=true"
import script from "./tradelist.vue?vue&type=script&lang=js"
export * from "./tradelist.vue?vue&type=script&lang=js"
import style0 from "./tradelist.vue?vue&type=style&index=0&id=5b6f2252&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6f2252",
  null
  
)

export default component.exports